import { render, staticRenderFns } from "./InsuranceManagement.vue?vue&type=template&id=5ccf48b7&scoped=true&"
import script from "./InsuranceManagement.vue?vue&type=script&lang=js&"
export * from "./InsuranceManagement.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceManagement.vue?vue&type=style&index=0&id=5ccf48b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf48b7",
  null
  
)

export default component.exports